import React, { useEffect, useState } from 'react';
import css from './index.module.scss';
import A from './components/A';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import G from './components/G';
import F from './components/F';
import H from './components/H';
import I from './components/I';
import { getCountriesList } from '@/service';
import { useLang } from '@/i18n';

const Page: React.FC = () => {
    const { t } = useLang('business');
    const [countries, setCountries] = useState<any>([]);
    const [active, setActive] = useState<string>(t('tab_title_4'));
    const getCountry = async () => {
        // 因国家/省/市列表只有英文的，所以暂时写死语言为 us
        const result: any = await getCountriesList(
            {
                page: 1,
                size: 300,
            },
            'us',
        );
        if (result?.code === '0') {
            const countryList: any = [];
            result.data?.content?.forEach((item: any) => {
                countryList.push({
                    key: item.id,
                    text: item.name,
                    phoneCode: item.phoneCode,
                });
            });
            // countryList.push({
            //     key: 404,
            //     text: t('other_country'),
            //     phoneCode: '',
            // });

            setCountries(countryList);
        }
    };
    useEffect(() => {
        getCountry();
    }, []);
    return (
        <section className={`${css.page}`}>
            <B callback={(i) => setActive(i)}></B>
            <A type={active}></A>
            {active === t('tab_title_4') || active === t('tab_title_5') ? <C type={active}></C> : <D type={active}></D>}
            {active === t('tab_title_4') && <E></E>}
            {active === t('tab_title_5') && (
                <>
                    <F></F>
                    <G></G>
                    <H></H>
                </>
            )}

            <I countryList={countries} type={active} />
        </section>
    );
};

export default Page;
